import React from "react"
import Lang from "@components/Lang/Lang"
import {Modal, Form, Input, DatePicker, Select,} from "antd"
import dayjs from 'dayjs'
import './ExportData.less'
import {getSomeTimeMilliseconds} from '@/utils/timeHandler'

const { Option } = Select
const { RangePicker } = DatePicker;
const config = require("../../../../config/config");
const Locale = require("../../../utils/locale").default;
let locale = Locale.current();

const ExportData = (props) => {
    // console.log('props.isModalVisible', props.isModalVisible);

    const [form] = Form.useForm()

    const handleOk = () => {
        // setIsModalVisible(false);
        // props.showSwich(false)
        // console.log(form.getFieldsValue());
        const formData = form.getFieldsValue() || {}

        // console.log(dayjs(formData.time[0]._d).valueOf());
         let template =
             locale === "ru" ? "MgRefundRecordReport_ru" : "MgRefundRecordReport_zh";
         let href = config.servers[config.environment].exportApi +
             `/data/bpms/jreport/mg/refundRecord/print?template=${template}&%24isGetHttpConfig=true&isCheck=0`;
         //地址拼接，如果没有数据也要拼接
         href += `&startTime=${(formData.time&&getSomeTimeMilliseconds(formData.time[0], '00:00:00')) || ""}`;
         href += `&endTime=${(formData.time&&getSomeTimeMilliseconds(formData.time[1], '23:59:59')) || ""}`;
        href += `&langCode=${locale}`
        href += `&status=${formData.status || 0}`
        href += `&refundTypeCode=${formData.refundTypeCode || ''}`

         window.open(href);

        props.showSwich(false)
    };

    const handleCancel = () => {
        // setIsModalVisible(false);
        props.showSwich(false)
    };
    return (
        <Modal title={Lang({id: 'DaoChuShuJuShaiXuan', default: '导出数据筛选'})}
               className="refund-statistics-exportModal"
               open={props.isModalVisible}
               onOk={handleOk}
               onCancel={handleCancel}
               cancelText={Lang({id: 'QuXiao', default: '取消'})}
               cancelButtonProps={{shape:'round'}}
               okButtonProps={{type:'primary', shape:'round'}}
               okText={Lang({id: 'DaoChu', default: '导出'})}>
            <Form labelCol={{span: locale === "ru" ? 7 : 5}}
                  form={form}
                  labelAlign="left">
                <Form.Item
                    name="time"
                    label={(
                    <span className="label-txt">{Lang({id: 'ChuLiShiJian', default: '处理时间'})}</span>
                )}>
                    <RangePicker
                        style={{width: '312px'}}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="status"
                    label={(
                        <span className="label-txt">{Lang({id: 'ChuLiZhuangTai', default: '处理状态'})}</span>
                    )}>
                    <Select style={{ width: 312 }}>
                        <Option value={0}>{Lang({id: 'QuanBu', default: '全部'})}</Option>
                        <Option value={1}>{Lang({id:'DaiTuiKuan', default:'待退款'})}</Option>
                        <Option value={2}>{Lang({id:'YiTuiKuan', default:'已退款'})}</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="refundTypeCode"
                    label={(
                        <span className="label-txt">{Lang({id: 'FuWuLeiXing', default: '服务类型'})}</span>
                    )}>
                    <Select style={{ width: 312 }}>
                        <Option value="">{Lang({id: 'QuanBu', default: '全部'})}</Option>
                        {__getDictList('fin_refund_from_type').map((item,index) => (
                            <Option key={index} value={item.code}>{item.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ExportData
